import * as _ from 'lodash';

/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { MenuItem } from 'primeng/api/menuitem';
import { SelectItem } from 'primeng/api/selectitem';

import { AppUtilityService } from '../../../core/services/app-utility.service';
import { BaseResponse } from '../../../core/model/base-response.model';
import { BreTransferAreaDetails } from '../../../core/model/bre-transfer-area-details.model';
import { ConfigService } from './../../../core/services/config.service';
import { EditModeService } from '../../../core/services/edit-mode.service';
import { UntypedFormGroup } from '@angular/forms';
import { Header } from '../../../core/model/header.model';
import { LmsException } from './../../../core/model/lms-exception.model';
import { LmsLoaderService } from './../../../core/services/lms-loader.service';
import { LmsModuleService } from '../../../core/services/lms-module.service';
import { LocoDataService } from '../../services/loco-data.service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { LocoIncident } from '../../shared/model/loco-incident.model';
import { LocoIncidentService } from './../../../core/services/loco-incident-service';
import { LocoTransfer } from '../../../core/model/loco-transfer.model';
import { LocomotiveErrors } from '../../../core/model/locomotive-error.model';
import { MessageDetails } from '../../../core/model/message-details.model';
import { MessageHandlerService } from './../../../core/services/message-handler.service';
import { PopupService } from '../../../core/services/popup.service';
import { Router } from '@angular/router';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { Tab } from './../../../core/model/tab.model';
import { TabService } from '../../../core/services/tab.service';
import { TerminalCommonInfo } from '../../../core/model/terminal-common-info.model';
import { TerminalHandlingLocoInfo } from '../../../core/model/terminal-handling-loco-info.model';
import { TerminalHandlingUpdateRequest } from '../../../core/model/terminal-handling-update-request-model';
import { TerminalRoad } from './../../../core/model/terminal-road-model';
import { environment } from './../../../../environments/environment';
import { UserService } from '../../../core/services/user.service';

/**
 * @export
 * @class LmsLocoTopActionsComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-loco-top-actions',
  templateUrl: './lms-loco-top-actions.component.html',
  styleUrls: ['./lms-loco-top-actions.component.scss']
})
export class LmsLocoTopActionsComponent implements OnInit, OnDestroy, OnChanges {

  @Input() subTypes: Array<string>;

  @Input() locoSVG: LocoDetail;

  @Input() tab: Tab;
  @Output() locoAddInit: EventEmitter<string> = new EventEmitter<string>();
  @Output() editTab: EventEmitter<Tab> = new EventEmitter<Tab>();
  @Input() locoEditForm: UntypedFormGroup;


  locoIcon: LocoDetail;
  tabLevel: number;
  responseHeader: Header; // Delete Response
  baseResponse: BaseResponse; // Transfer and UTH Response
  popupErrorMessage: string; // Pop Up Heading

  otherOptions: MenuItem[]; // Top Action MenuItem
  // Pop up Starts
  bringOnline = false;
  planLocomotive = false;
  terminalPlan = false;
  addLocomotive = false;
  deleteLocomotive = false;
  yardAndLocal = false;
  ruleException = false;
  // Pop up ends
  // Drop Down starts
  locoDirection: SelectItem[];
  classValue: SelectItem[];
  planOptions: SelectItem[];
  selectedRoadValues: SelectItem[];
  roadValues: Array<TerminalRoad>;
  // Drop Down ends
  locoPlannedTo: string; // Plan Loco/Bring Online  Drop Down value
  minDateValue: Date = new Date(); //  Minimum value which can be selected from calendar
  selectedTerminalRoad: string; // Road value
  errorDialog = false; // To show error on Popup
  addLocoDetails: LocoDetail; // request object for Add loco
  errorMap: Map<string, boolean> = new Map<string, boolean>(); // Handling of Errors in Add Loco
  addResponse: LocomotiveErrors; // Add Loco Response
  addResponseError: LocomotiveErrors = {}; // Add Loco Response
  defaultClass: string; // Class Value
  defaultDirection: string; // Direction Value
  thpPlan = 'S'; // Handling Type Value
  isValidThpSelection = false;
  searchTextTerminal: string; // Terminal suggestive Search Value
  searchTextTrain: string; // Train Search Value
  mileposts: string[] = []; // Milepost Value
  mnemonics: string[] = []; // Mnemonics Value
  filteredResults: string[] = []; // Filtered Array from suggestive Search of Teminals
  popUpTypeBre: string; // check which pop up is opened
  dialog: any;
  configData: any;
  lmsExceptionList: Array<LmsException> = [];
  isRuleExceptionSubmitEnabled: boolean;
  searchPlanTextTerminalError: boolean;
  selectedTerminalRoadError: boolean;
  isAddTrainError: boolean;
  terminalCommonInfoArr: Array<TerminalCommonInfo>; // This is terminal info array which we are using for getting City and state
  popUpTabIndex: number;
  popUpServiceSubscription: any;
  iconSubscription: any;
  lastRequestTime: number;
  iconIdentified: boolean;
  breakCall = false;
  allocateRole: string;
  /**
   * Creates an instance of LmsLocoTopActionsComponent.
   * Also Add values to Drop Down of Top actions.
   * @param {ConfigService} configService
   * @memberOf LmsLocoTopActionsComponent
   */
  constructor(private configService: ConfigService, private staticDataStoreService: StaticDataStoreService,
    private locoDataService: LocoDataService, private messageHandlerService: MessageHandlerService,
    private lmsModuleService: LmsModuleService, private editModeService: EditModeService,
    private router: Router, private popupService: PopupService, private appUtilityService: AppUtilityService,
    private lmsLoaderService: LmsLoaderService, private tabService: TabService,
    private locoIncidentService: LocoIncidentService, 
    public user: UserService) {
    this.configData = this.configService.getConfigData();
    this.tabLevel = this.configService.getConfigData().tabIndex.subTabs;
    this.dialog = this.configService.getConfigData().dialog;
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist &&
      commonopsPicklist.masterData &&
      commonopsPicklist.masterData.userAuthDetails &&
      commonopsPicklist.masterData.userAuthDetails.allocationRole) {
      this.allocateRole = commonopsPicklist.masterData.userAuthDetails.allocationRole;
    }

    if (commonopsPicklist && commonopsPicklist.setOfTerminals) {
      this.terminalCommonInfoArr = [];
      this.terminalCommonInfoArr = commonopsPicklist.setOfTerminals;
    }
    this.popUpTabIndex = this.configData.tabIndex.dialogBox;
    this.otherOptions = [];
    this.locoDirection = [];
    this.classValue = [];
    this.roadValues = [];
    this.selectedRoadValues = [];
    this.addLocoDetails = {};
    this.prepareOtherOptionsMenu();
    this.createErrorMap();
    this.generateDirectionDropDown();
    this.defaultDirection = '';
    this.generateClassNRoadValues(commonopsPicklist);
    this.planOptions = [];
    this.popUpServiceSubscription = this.popupService.popupOprObservable.subscribe((data) => {
      this.checkSuccessOperation(data);
    });
  }

  checkSuccessOperation(opr: any) {
    if (opr && (opr.operation === 'updateIntendedSuccess' || opr.operation === 'allocateSuccess' || opr.operation === 'deallocateSuccess') && this.tab && this.tab.subTypeDetail) {
      this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status = 'refresh';
      this.locoDataService.load(this.tab, true, opr.message);
    } else if ((opr.operation === 'deAllocateError' || opr.operation === 'allocateLocoError') && this.tab && this.tab.subTypeDetail && this.tab.subTypeDetail.data) {
      this.tab.subTypeDetail.data.message = opr.message;
    }
  }
  /**
   * Set Thp Type for UTHP
   * @private
   * @memberof LmsLocoTopActionsComponent
   */
  private checkThpPlanType() {
    if ('Svc Ctr/Shop' === this.locoSVG.thpType) {
      this.thpPlan = 'S';
    } else if ('Truck Fuel' === this.locoSVG.thpType) {
      this.thpPlan = 'T';
    } else if ('Main Track' === this.locoSVG.thpType) {
      this.thpPlan = 'M';
    } else if ('Storage' === this.locoSVG.thpType) {
      this.thpPlan = 'X';
    } else {
      this.thpPlan = '';
    }
    if ('S' === this.thpPlan && !this.appUtilityService.isValidThpSelection(this.locoSVG.thpTerminal)) {
      this.thpPlan = '';
    }
    if ('X' === this.thpPlan && this.user && this.user.isUserManagerOrDirector) {
      this.thpPlan = '';
    }
  }

  /**
   * Generate Class N road values
   * @param {*} commonopsPicklist
   * @memberOf LmsLocoTopActionsComponent
   */
  private generateClassNRoadValues(commonopsPicklist: any) {
    if (commonopsPicklist && commonopsPicklist.masterData) {
      if (commonopsPicklist.masterData.classCodeList && commonopsPicklist.masterData.classCodeList.length > 0) {
        this.classValue.push({
          label: 'Select',
          value: ''
        });
      }
      for (let i = 0; i < commonopsPicklist.masterData.classCodeList.length; i++) {
        this.classValue.push({
          label: commonopsPicklist.masterData.classCodeList[i],
          value: commonopsPicklist.masterData.classCodeList[i]
        });
      }
      if (commonopsPicklist.masterData.interchangeList && commonopsPicklist.masterData.interchangeList.length > 0) {
        for (let i = 0; i < commonopsPicklist.masterData.interchangeList.length; i++) {
          const terminalRoad: TerminalRoad = commonopsPicklist.masterData.interchangeList[i];
          this.roadValues.push(terminalRoad);
        }
      }
      this.defaultClass = this.classValue[0].value;
    }
  }
  /**
   * Generate Direction Drop Down
   * @memberOf LmsLocoTopActionsComponent
   */
  private generateDirectionDropDown() {
    this.locoDirection.push({
      label: 'Select',
      value: ''
    });
    this.locoDirection.push({
      label: 'Unknown',
      value: ' '
    });
    this.locoDirection.push({
      label: 'Forward',
      value: 'F'
    });
    this.locoDirection.push({
      label: 'Backward',
      value: 'B'
    });
  }

  /**
   * Create Error Map used in Add Loco
   * @memberOf LmsLocoTopActionsComponent
   */
  private createErrorMap() {
    this.errorMap.set('classError', false);
    this.errorMap.set('directionFacingError', false);
    this.errorMap.set('horsePowerError', false);
    this.errorMap.set('responsibleRoadError', false);
    this.errorMap.set('fuelLevelError', false);
    this.errorMap.set('milesError', false);
    this.errorMap.set('capacityError', false);
    this.errorMap.set('mixedRangeError', false);
    this.errorMap.set('bulkRangeError', false);
    this.errorMap.set('manifestRangeError', false);
    this.errorMap.set('permanentTagError', false);
    this.errorMap.set('nextQDateError', false);
    this.errorMap.set('rduInstalledError', false);
    this.errorMap.set('locoTagError', false);
    this.errorMap.set('nextDailyMIDueDateError', false);
    this.errorMap.set('nextAirFlowDateError', false);
  }

  /**
   * This method is used to edit the Locomotive Details
   * @memberOf LmsLocoTopActionsComponent
   */
  public editLocomotiveDetails() {
    this.tab.mode = 'edit';
    setTimeout(() => {
      this.popupService.setPageMode('Edit');
      this.popupService.setSubmitBtnId('locoDataSubmitButton');
    }, 20);
    this.editTab.emit(this.tab);
    setTimeout(() => {
      this.checkEditModeStatus();
      this.moveFocusToFirstElement();
    }, 5);
  }

  private moveFocusToFirstElement() {
    const form = document.forms && document.forms.length > 0 ? document.forms : null;
    if (form) {
      const inp = document.forms[0].querySelector('input');
      if (inp) {
        setTimeout(function () {
          inp.focus();
        }, 10);
      }
    }
  }

  /**
   * This method is used to cancel the edit operation
   * @memberOf LmsLocoTopActionsComponent
   */
  public cancelLocomotiveEdit() {
    this.tab.mode = 'view';
    this.resetDefaultPageMode();
    this.checkEditModeStatus();
    setTimeout(() => {
      this.editTab.emit(this.tab);
    }, 5);
  }


  /**
   * @memberOf LmsLocoTopActionsComponent
   */
  ngOnInit() {
  }


  /**
   * @memberOf LmsLocoTopActionsComponent
   */
  ngOnChanges() {
    this.prepareOtherOptionsMenu();
    if (this.tab && this.tab.subTypeDetail && (this.tab.subTypeDetail.data.status === 'loaded' || this.tab.subTypeDetail.data.status === 'refresh')) {
      if (this.tab.tabSearchParameter && this.tab.tabSearchParameter.icon) {
        if (this.tab.subTypeDetail.data.status === 'loaded') {
          this.locoIcon = this.tab.tabSearchParameter.icon;
          this.crossCheckLocoIcon();
        } else if (this.tab.subTypeDetail.data.status === 'refresh') {
          this.refreshLocomotiveIconInformation();
        }
      } else if (this.tab && this.tab.tabSearchParameter && this.tab.tabSearchParameter.searchText) {
        this.refreshLocomotiveIconInformation();
      }
    }
  }

  private refreshLocomotiveIconInformation() {
    const currentTime = (new Date()).getTime();
    if (!this.lastRequestTime || (currentTime - this.lastRequestTime) > 600) {
      this.popupService.getLocomotiveIconInformation(this.tab, this.tab.tabSearchParameter.searchText);
      this.iconSubscription = this.popupService.locoIconObservable.subscribe((data) => {
        if (data) {
          this.locoIcon = data.data;
          this.iconIdentified = data && data.opr && data.opr === 'success' ? true : false;
        }
        this.crossCheckLocoIcon();
      });
      this.lastRequestTime = currentTime;
    }
  }

  private crossCheckLocoIcon() {
    if (!this.locoIcon || !this.locoIcon.locomotiveIdentifier ) {
      this.locoIcon = this.locoSVG;
      if (!this.locoIcon) {
        this.locoIcon = {};
      }
      if (!this.locoIcon.locomotiveIdentifier) {
        this.locoIcon.locomotiveIdentifier = this.tab.tabSearchParameter.searchText;
      }
    } else {
      this.iconIdentified = true;
    }
  }


  /**
   * Actions taken on click from Menu Item
   * @param {string} type
   * @param {string} label
   * @memberOf LmsLocoTopActionsComponent
   */
  private otherActionsTaken(type: string, label: string) {
    this.errorDialog = false;
    this.resetPopUpValues();
    this.popupErrorMessage = label;
    this.lmsLoaderService.hideLoader();
    if (type && (type == 'allocate')) {
      const locoDataArr: Array<LocoDetail> = [];
      locoDataArr.push(this.locoSVG);
      const operation = {
        operation: 'AllocateLocomotives',
        data: locoDataArr,
        windowCode: 'LWLD'
      };
      this.popupService.setPopupOperation(operation);
    } else  if (type && (type == 'deallocate')){
      const locoDataArr: Array<LocoDetail> = [];
      locoDataArr.push(this.locoSVG);
      const operation = {
        operation: 'DeallocateLocomotives',
        data: locoDataArr,
        windowCode: 'LWTD'
      };
      this.popupService.setPopupOperation(operation);
    } else if (type && ((type !== 'planLocomotive') && (type !== 'bringOnline'))) {
      this[type] = true;
    }
    this.popupService.setPageMode('Dialog');
    this.popupService.setSubmitBtnId(type + 'LocoData');
    this.generatePlanOption(type);
  }

  /**
   * Generate Plan Options
   * @param {string} type
   * @memberOf LmsLocoTopActionsComponent
   */
  private generatePlanOption(type: string) {
    if ('planLocomotive' === type) {
      this.getLocoIncident(this.locoSVG, 'planLocomotive');
      this.planOptions.push({
        label: this.dialog.planLocomotive.planOptions.train,
        value: 'train',
      });
      this.planOptions.push({
        label: this.dialog.planLocomotive.planOptions.terminal,
        value: 'terminal'
      });
      this.planOptions.push({
        label: this.dialog.planLocomotive.planOptions.foreignRailRoad,
        value: 'foreignRailRoad'
      });
    } else if ('bringOnline' === type || 'addLocomotive' === type) {
      if ('bringOnline' === type) {
        this.getLocoIncident(this.locoSVG, 'bringOnline');
      }
      this.planOptions.push({
        label: this.dialog.planLocomotive.planOptions.train,
        value: 'train',
      });
      this.planOptions.push({
        label: this.dialog.planLocomotive.planOptions.terminal,
        value: 'terminal'
      });
    }
  }

  /**
   * Check for TRF Incident. 
   * 
   * @param {LocoDetail} locoData 
   * @returns 
   * @memberof LmsLocoTopActionsComponent
   */
  isTrfIncident(locoData: LocoDetail) {
    let isTrfIncident = false;
    if (locoData && locoData.listOfIncident) {
      for (let i = 0; i < locoData.listOfIncident.length; i++) {
        const locoIncident: LocoIncident = locoData.listOfIncident[i];
        if (locoIncident && locoIncident.incidentCode && locoIncident.incidentCode.trim().toUpperCase() === 'TRF') {
          isTrfIncident = true;
          break;
        }
      }
    }
    return isTrfIncident;
  }
  /**
  * Get loco incident from locomotive identifier.
  * @param {string} locoId
  * @memberof LmsLocoTopActionsComponent
  */
  getLocoIncident(locoData: LocoDetail, popup: string) {
    if (locoData && locoData.locomotiveIdentifier) {
      if (locoData && locoData.deadFlag && locoData.deadFlag.trim().toUpperCase() === 'Y') {
        locoData.locoIncident = 'OOS';

      } else if (this.isTrfIncident(locoData)) {
        locoData.locoIncident = 'TRF';

      } else if (locoData.axles && locoData.axles.trim() === '4') {
        locoData.locoIncident = '4-ax';

      } else if (!locoData.axles || (locoData.axles && (locoData.axles.trim().length === 0 || locoData.axles.trim() === '6'))) {
        locoData.locoIncident = '6-ax';

      }
      if (popup === 'planLocomotive' || popup === 'bringOnline') {
        this[popup] = true;
        setTimeout(() => {
          if (popup === 'planLocomotive') {
            this.setFocusToGivenElement('locoDataPlanTrnInput');
          } else if (popup === 'bringOnline') {
            this.setFocusToGivenElement('bringOnlineTrnInput');
          }
        }, 20);
      }
    }
  }
  /**
   * @private
   * @memberOf LmsLocoTopActionsComponent
   */
  private checkEditModeStatus() {
    if (this.tab && this.tab.subTypeDetail && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded' && this.tab.mode === 'edit') {
      const editModeStatus = {
        status: true,
        message: 'Unsaved data will be lost. Do you want to continue?'
      };
      this.editModeService.setEditMode(editModeStatus);
    } else {
      const editModeStatus = {
        status: false,
        message: ''
      };
      this.editModeService.setEditMode(editModeStatus);
    }
  }
  /**
   * Reset All the default Values
   * @memberOf LmsLocoTopActionsComponent
   */
  private resetPopUpValues() {
    this.locoPlannedTo = 'train';
    this.thpPlan = 'S';
    this.selectedTerminalRoad = '';
    this.selectedRoadValues = [];
    this.planOptions = [];
    this.selectedRoadValues.push({
      label: '',
      value: ''
    });
    this.searchTextTrain = '';
    this.searchTextTerminal = '';
    this.defaultDirection = '';
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist && commonopsPicklist.masterData) {
      if (commonopsPicklist.masterData.classCodeList && commonopsPicklist.masterData.classCodeList.length > 0) {
        this.classValue.push({
          label: 'Select',
          value: ''
        });
      }
      for (let i = 0; i < commonopsPicklist.masterData.classCodeList.length; i++) {
        this.classValue.push({
          label: commonopsPicklist.masterData.classCodeList[i],
          value: commonopsPicklist.masterData.classCodeList[i]
        });
      }
      if (this.classValue && this.classValue.length > 0) {
        this.defaultClass = this.classValue[0].value;
      }
    }
    this.createErrorMap();
    this.addResponseError = {};
  }



  /**
   * Reset values on drop down value change
   * @memberOf LmsLocoTopActionsComponent
   */
  changePlanOptions(type?: string) {
    this.popupErrorMessage = type;
    this.errorDialog = false;
    this.searchTextTerminal = '';
    this.selectedTerminalRoad = '';
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoadError = false;
    this.isAddTrainError = false;
    this.searchTextTrain = '';
    this.thpPlan = 'S';
    this.isValidThpSelection = false;
    this.selectedRoadValues = [];
    this.selectedRoadValues.push({
      label: '',
      value: ''
    });
    setTimeout(() => {
      if ('Plan Locomotive' === type) {
        if (this.locoPlannedTo && this.locoPlannedTo === 'foreignRailRoad') {
          this.setFocusToGivenElement('locoDataTerminalSuggstInput');
        } else if (this.locoPlannedTo && this.locoPlannedTo === 'train') {
          this.setFocusToGivenElement('locoDataPlanTrnInput');
        } else if (this.locoPlannedTo && this.locoPlannedTo === 'terminal') {
          this.setFocusToGivenElement('locoDataTerminalSuggstInput');
        }
      } else if ('Add Locomotive' === type) {
        if (this.locoPlannedTo && this.locoPlannedTo === 'train') {
          this.setFocusToGivenElement('locoDataAddLocoTrnInput');
        } else {
          this.setFocusToGivenElement('locoDataAddLocoInput');
        }
      }
    }, 5);
  }

  /**
   * Delete Loco Service Call
   * @memberOf LmsLocoTopActionsComponent
   */
  deleteExistingLocomotive() {
    this.lmsLoaderService.showLoader();
    const origLocoId = this.appUtilityService.formatLocomotiveId(this.tab.tabSearchParameter.searchText);
    this.locoDataService.deleteExistingLocomotive(this.locoSVG.currentAssignment, origLocoId).subscribe(
      (data) => {
        this.deleteSubscribeMethod(data);
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.deleteLocomotive = false;
        if (this.tab && this.tab.subTypeDetail) {
          this.tab.subTypeDetail[this.tab.subType.toLowerCase()].message = this.appUtilityService.getHttpErroMessage(error, false);
        }
        this.lmsModuleService.updateSelectedTab(this.tab);
        this.resetDefaultPageMode();
      });
  }

  /**
   * Delete Subscribe Method
   * @param {*} data
   * @memberof LmsLocoTopActionsComponent
   */
  deleteSubscribeMethod(data: any) {
    this.responseHeader = data;
    if (this.appUtilityService.isNumeric(this.responseHeader.priorityCode)) {
      const pCode = parseInt(this.responseHeader.priorityCode, 10);
      if (pCode >= 1 && pCode <= 4) {
        this.lmsLoaderService.hideLoader();
        this.deleteLocomotive = false;
        this.lmsModuleService.removeTab(this.tab);
        const newTab = <Tab>({
          type: this.tab.type, subType: this.tab.subType, tabSearchParameter: '',
          status: this.configService.getConfigData().tabStatus.blank
        });
        if (this.tab) {
          this.appUtilityService.navigateByUrl(this.tab.type, this.tab.subType, '', true);
        }
        this.messageHandlerService.handleMessage(<MessageDetails>({
          type: this.configData.message.type.client,
          level: this.configData.message.level.success,
          target: this.configData.message.target.page,
          message: this.responseHeader.messageText
        }));
        this.resetDefaultPageMode();
      } else {
        this.lmsLoaderService.hideLoader();
        this.deleteLocomotive = false;
        if (this.tab && this.tab.subTypeDetail) {
          this.tab.subTypeDetail[this.tab.subType.toLowerCase()].message = this.responseHeader.messageText;
        }
        this.lmsModuleService.updateSelectedTab(this.tab);
        this.resetDefaultPageMode();
      }
    }
  }

  /**
   * Add Loco Service Call
   * @param {any} form
   * @memberOf LmsLocoTopActionsComponent
   */
  addNewLocomotive(form) {
    this.lmsLoaderService.showLoader();
    this.addLocoDetails = form.value;
    this.createErrorMap();
    if (!this.appUtilityService.isValidLocomotiveId(
      this.appUtilityService.UIformatLocomotiveId(this.addLocoDetails.locomotiveIdentifier))) {
      this.isValidLocoInAddLoco();
    } else if ('train' === this.locoPlannedTo && !this.appUtilityService.isValidTrainId(this.searchTextTrain)) {
      this.isValidTrainInAddLoco();
    } else if ('terminal' === this.locoPlannedTo && !this.appUtilityService.isMnemonicExist(this.searchTextTerminal)) {
      this.isValidTerminalInAddLoco();
    } else {
      if ('terminal' === this.locoPlannedTo) {
        this.addLocoDetails.currentAssignment = this.searchTextTerminal ? this.searchTextTerminal.toUpperCase() : '';
      } else if ('train' === this.locoPlannedTo) {
        this.addLocoDetails.currentAssignment = this.searchTextTrain ? this.searchTextTrain.toUpperCase() : '';
      }
      const origLocoId = this.addLocoDetails.locomotiveIdentifier;
      this.addLocoDetails.locomotiveIdentifier = this.appUtilityService.formatLocomotiveId(this.addLocoDetails.locomotiveIdentifier);
      this.locoDataService.addLocomotive(this.addLocoDetails).subscribe(
        (data) => {
          this.subscribeAddLoco(data, origLocoId);
        }, error => {
          this.lmsLoaderService.hideLoader();
          this.errorDialog = true;
          this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
        });
    }
  }

  /**
   * Check if loco id is valid
   * @memberof LmsLocoTopActionsComponent
   */
  isValidLocoInAddLoco() {
    this.lmsLoaderService.hideLoader();
    this.errorDialog = true;
    this.popupErrorMessage = 'Enter Valid Locomotive ID';
  }

  /**
   * Check if terminal id is valid
   * @memberof LmsLocoTopActionsComponent
   */
  isValidTerminalInAddLoco() {
    this.lmsLoaderService.hideLoader();
    this.errorDialog = true;
    this.popupErrorMessage = 'Enter Valid Terminal Mnemonic';
  }

  /**
   * Check if train id is valid
   * @memberof LmsLocoTopActionsComponent
   */
  isValidTrainInAddLoco() {
    this.lmsLoaderService.hideLoader();
    this.errorDialog = true;
    this.popupErrorMessage = 'Enter Valid Train ID';
  }

  /**
   * Subscribe method add loco
   * @param {*} data
   * @param {string} origLocoId
   * @memberof LmsLocoTopActionsComponent
   */
  subscribeAddLoco(data: any, origLocoId: string) {
    if (data && data != null) {
      this.addResponse = data;
      if (this.appUtilityService.isNumeric(this.addResponse.header.priorityCode)) {
        const pCode = parseInt(this.addResponse.header.priorityCode, 10);
        if (pCode >= 1 && pCode <= 4) {
          this.lmsLoaderService.hideLoader();
          this.addLocomotive = false;
          this.emitMethod();
          setTimeout(() => {
            const addLocoId = this.appUtilityService.UIformatLocomotiveId(origLocoId);
            this.lmsModuleService.removeTab(this.tab);
            if (this.tab) {
              this.appUtilityService.navigateByUrl(this.tab.type, this.tab.subType, addLocoId, true);
            }
          }, 50);

          this.messageHandlerService.handleMessage(<MessageDetails>({
            type: this.configData.message.type.client,
            level: this.configData.message.level.success,
            target: this.configData.message.target.page,
            message: this.addResponse.header.messageText
          }));
          this.resetDefaultPageMode();
        } else {
          this.lmsLoaderService.hideLoader();
          this.addResponseError = data;
          this.defaultClass = this.addResponseError.clazz;
          this.defaultDirection = this.addResponseError.directionFacing;
          this.addResponseError.locomotiveIdentifier =
            this.appUtilityService.UIformatLocomotiveId(this.addLocoDetails.locomotiveIdentifier);
          this.errorDialog = true;
          this.errorMap.forEach((value: boolean, key: string) => {
            if ('C' === this.addResponse[key] || 'H' === this.addResponse[key]) {
              this.errorMap.set(key, true);
            }
          });
          this.popupErrorMessage = this.addResponse.header.messageText;
        }
      }
    } else {
      this.lmsLoaderService.hideLoader();
      this.errorDialog = true;
      this.popupErrorMessage = 'CANNOT ADD - LOCOMOTIVE ALREADY EXISTS';
    }
  }

  private emitMethod() {
    this.locoAddInit.emit('addLoco');
  }
  /**
   * Converts Loco id to possible Value
   * @memberOf LmsLocoTopActionsComponent
   */
  convertLocoId() {
    if (this.addResponseError.locomotiveIdentifier) {
      this.addResponseError.locomotiveIdentifier = this.appUtilityService.UIformatLocomotiveId(this.addResponseError.locomotiveIdentifier);
    }
  }


  /**
   * Generating values in suggestive Search
   * @param {any} event
   * @memberOf LmsLocoTopActionsComponent
   */
  autoCompleteForTerminal(event) {
    this.mnemonics = [];
    this.mileposts = [];
    this.selectedRoadValues = [];
    this.selectedTerminalRoad = '';
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist) {
      const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          this.mnemonics.push(data[key]);
          this.mileposts.push(key);
        }
      }
    }
    this.filteredResults = this.mnemonics.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    });

    Array.prototype.push.apply(this.filteredResults, (this.mileposts.filter((s) => {
      return s.startsWith(event.query.toUpperCase());
    })));
    this.filteredResults = this.filteredResults.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) === index;
    });
    this.filteredResults.sort();
  }

  /**
   * Selecting Values From suggestive Search
   * @param {string} value
   * @memberOf LmsLocoTopActionsComponent
   */
  selectValueFromAutoComplete(value: string, type: string) {
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoadError = false;
    let emitValue = value;
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist) {
      const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
      if (data) {
        if (data[value]) {
          emitValue = data[value];
        }
      }
    }
    if (this.roadValues) {
      this.selectedRoadValues = [];
      const filteredRoadValues: Array<TerminalRoad> = this.roadValues.filter((terminalRoad) => {
        return terminalRoad.terminal === emitValue;
      });
      if (filteredRoadValues && filteredRoadValues.length > 0) {
        this.selectedRoadValues.push({
          label: 'Select',
          value: 'Select'
        });
      }
      for (const filteredRoadValue of filteredRoadValues) {
        this.selectedRoadValues.push({
          label: filteredRoadValue.road,
          value: filteredRoadValue.road
        });
        this.selectedTerminalRoad = this.selectedRoadValues[0].value;
      }
      if (this.locoPlannedTo === 'foreignRailRoad') {
        if (!filteredRoadValues || (filteredRoadValues && filteredRoadValues.length <= 0)) {
          this.errorDialog = true;
          this.popupErrorMessage = this.configData.messages.planInvalidInterchangeRoad;
        } else {
          this.popupErrorMessage = 'Plan Locomotive';
          this.errorDialog = false;
        }
      }
    }
    this.searchTextTerminal = emitValue;
    if (this.planLocomotive && !this.appUtilityService.isValidThpSelection(this.searchTextTerminal)) {
      this.thpPlan = 'M';
      this.isValidThpSelection = true;
    } else {
      this.thpPlan = 'S';
      this.isValidThpSelection = false;
    }
  }

  /**
   * Prepare Other Action Menu Item
   * @private
   * @memberOf LmsLocoTopActionsComponent
   */
  private prepareOtherOptionsMenu() {
    this.otherOptions = [
      {
        label: 'Plan Locomotive', command: () => {
          event.stopPropagation();
          this.lmsLoaderService.showLoader();
          this.otherActionsTaken('planLocomotive', 'Plan Locomotive');
        }, disabled: this.tab && this.tab.subTypeDetail && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded' ? false : true
      },
      {
        label: 'Locate', command: () => {
          event.stopPropagation();
          this.lmsLoaderService.showLoader();
          this.locateLocomotive();
        }, disabled: this.tab && this.tab.subTypeDetail && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded' ? false : true
      },
      {
        label: 'Update Terminal Handling Plan', command: () => {
          event.stopPropagation();
          this.lmsLoaderService.showLoader();
          this.otherActionsTaken('terminalPlan', 'Update Terminal Handling Plan');
          this.checkThpPlanType();
        }, disabled: this.tab && this.tab.subTypeDetail && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded' && this.locoSVG && this.locoSVG.thpTerminal ? false : true
      },
      {
        label: 'Update Intended Usage', command: () => {
          event.stopPropagation();
          this.getLocoIncident(this.locoSVG, 'intendedUsage');

        }, disabled: !(this.tab && this.tab.subTypeDetail && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded'
          && this.locoSVG && ((this.locoSVG.plannedAssignment && this.appUtilityService.isValidTrainId(this.locoSVG.plannedAssignment)) || (this.locoSVG.intendedUsageCode)))
      },
      {
        label: 'Bring Online', command: () => {
          event.stopPropagation();
          this.lmsLoaderService.showLoader();
          this.otherActionsTaken('bringOnline', 'Bring Online');
        }, disabled: (this.tab && this.tab.subTypeDetail && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded') &&
          (this.locoSVG && 'OFFLN' === this.locoSVG.currentAssignment ||
            'DELETE' === this.locoSVG.currentAssignment || 'NEW' === this.locoSVG.currentAssignment
            || 'PARKED' === this.locoSVG.currentAssignment) ? false : true
      },
      {
        label: 'Add Locomotive', command: () => {
          event.stopPropagation();
          this.lmsLoaderService.showLoader();
          this.otherActionsTaken('addLocomotive', 'Add Locomotive');
        },
      },
      {
        label: 'Delete Locomotive', command: () => {
          event.stopPropagation();
          this.lmsLoaderService.showLoader();
          this.otherActionsTaken('deleteLocomotive', 'Delete Locomotive');
        }, disabled: (this.tab && this.tab.subTypeDetail && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded') && this.tab.tabSearchParameter && this.tab.tabSearchParameter.searchText.indexOf('CSXT') === -1 ? false : true
      },
      {
        label: 'Allocate', command: () => {
          this.otherActionsTaken('allocate', 'Allocate');
        }, disabled:  (this.user && !this.user.isUserManagerOrDirector) || (!(this.tab && this.tab.subTypeDetail && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded') || (!this.allocateRole || (this.allocateRole && (this.allocateRole.toUpperCase().trim() !== 'YL' && this.allocateRole.toUpperCase().trim() !== 'MW'))))
      },
      {
        label: 'Deallocate', command: () => {
          this.otherActionsTaken('deallocate', 'Deallocate');
        }, disabled:  (this.user && !this.user.isUserManagerOrDirector) || (!(this.tab && this.tab.subTypeDetail && this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status === 'loaded') || (!this.allocateRole || (this.allocateRole && (this.allocateRole.toUpperCase().trim() !== 'YL' && this.allocateRole.toUpperCase().trim() !== 'MW'))))
      }
    ];
  }

  /**
   * Locate Locomotive according to Assignment
   * @memberOf LmsLocoTopActionsComponent
   */
  private locateLocomotive() {
    this.errorDialog = false;
    this.lmsLoaderService.hideLoader();
    if (this.locoSVG && this.locoSVG.locoAllocStation.trim().length > 0) {
      this.redirectToYardAndLocal(this.locoSVG.locoAllocDiv, this.locoSVG.locoAllocStation, this.locoSVG.locoAllocType);
    } else {
      if ('MW' === this.locoSVG.permanentTag.toUpperCase().trim() && 0 === this.locoSVG.locoAllocStation.trim().length) {
        this.redirectToYardAndLocal('ALLMOW', 'all', 'M');
      } else {
        if ('I' === this.locoSVG.qualifier.toUpperCase()
          || 'E' === this.locoSVG.qualifier.toUpperCase() || 'O' === this.locoSVG.qualifier.toUpperCase()) {
          this.showTrainTabData('Data', 'Train', this.locoSVG.currentAssignment, this.appUtilityService.UIformatLocomotiveId(this.locoSVG.locomotiveIdentifier));
        } else if ('S' === this.locoSVG.qualifier.toUpperCase()
          || 'W' === this.locoSVG.qualifier.toUpperCase() || 'Y' === this.locoSVG.qualifier.toUpperCase()) {
        } else if ('V' === this.locoSVG.qualifier.toUpperCase() && this.locoSVG.currentAssignment) {
          this.redirectToYardAndLocal(this.locoSVG.currentAssignment, 'all', 'A');
        } else {
          this.showTerminalTabData('Status', 'Terminal', this.locoSVG.currentAssignment, this.appUtilityService.UIformatLocomotiveId(this.locoSVG.locomotiveIdentifier));
        }
      }
    }
  }

  /**
   * Redirect to yard and local screen.
   * @memberof LmsLocoTopActionsComponent
   */
  redirectToYardAndLocal(division?: string, allocationStation?: string, allocationType?: string) {
    if (this.locoSVG) {
      if (this.tabService.isTabRedirectionAllowed('yard-local', 'data')) {
        const yarLocalRouteParams = `division=${division}&allocationStation=${allocationStation}&allocationType=${allocationType}&locomotiveId=${this.locoSVG.locomotiveIdentifier}`;
        this.router.navigateByUrl(`/yard-local/data/${new Date().getTime()}?${yarLocalRouteParams}`,
          { skipLocationChange: environment.hideUrl });
      } else {
        this.messageHandlerService.handleMessage(<MessageDetails>({
          type: this.configService.getConfigData().message.type.client,
          level: this.configService.getConfigData().message.level.error,
          target: this.configService.getConfigData().message.target.page,
          message: this.configService.getConfigData().messages.maxTab
        }));
      }
    }
  }
  /**
   * Default Enter to Yard And Local
   * @memberOf LmsLocoTopActionsComponent
   */
  private setDefaultEnterToYardAndLocal() {
    this.popupService.setPageMode('Dialog');
    this.popupService.setSubmitBtnId('yardAndLocalLocoData');
  }

  /**
   * Cancel Loco operation on Clickin of Cancel Button and closes the pop up
   * @param {string} type
   * @memberOf LmsLocoTopActionsComponent
   */
  cancelOperation(type: string) {
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoadError = false;
    this.isAddTrainError = false;
    this.errorDialog = false;
    this.resetDefaultPageMode();
    this[type] = false;
    if (type === 'ruleException') {
      this.locoPlannedTo = 'train';
      this.changePlanOptions();
      if ('planLocomotive' === this.popUpTypeBre) {
        if (this.locoSVG) {
          this.locoSVG.intendedUsgaeNoteRequired = false;
        }
        this.popupErrorMessage = 'Plan Locomotive';
        this.planLocomotive = true;
        this.popupService.setPageMode('Dialog');
        this.popupService.setSubmitBtnId('planLocomotiveLocoData');
      } else if ('bringOnline' === this.popUpTypeBre) {
        this.popupErrorMessage = 'Bring Online';
        this.bringOnline = true;
        this.popupService.setPageMode('Dialog');
        this.popupService.setSubmitBtnId('bringOnlineLocoData');
      }
      this.isRuleExceptionSubmitEnabled = false;
    }
  }

  setPageMode(btnId: string, dialogId?: string) {
    if (btnId && btnId.length > 0) {
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId(btnId);
      setTimeout(() => {
        this.appUtilityService.setFocusToFirstElement(dialogId);
      }, 20);
    } else {
      this.resetDefaultPageMode();
    }
    this.focusOnDialog('locoRuleExceptionPopup');
  }


  /**
   * Service Call For Loco Transfer
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} operation
   * @param {string} popup
   * @memberOf LmsLocoTopActionsComponent
   */
  private serviceCallLocoTransfer(locoTransfer: Array<LocoTransfer>, operation: string, popup: string) {
    const windowCode = (popup && popup === 'bringOnline') ? 'LWLD' : 'LMLS';
    this.locoDataService.transferLocomotive(locoTransfer, operation, windowCode).subscribe(
      (data) => {
        this.baseResponse = <BaseResponse>data;
        if (this.appUtilityService.isNumeric(this.baseResponse.header.priorityCode)) {
          const pCode = parseInt(this.baseResponse.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this[popup] = false;
            if (this.tab && this.tab.subTypeDetail) {
              this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status = 'refresh';
            }
            this.locoDataService.load(this.tab, true, this.baseResponse.header.messageText);
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popupErrorMessage = this.baseResponse.header.messageText;
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      });
  }

  /**
   * Submit operation of Plan Loco,Bring Online and update Terminal Handling Plan
   * @param {string} type
   * @memberOf LmsLocoTopActionsComponent
   */
  submitOperation(type: string) {
    this.lmsLoaderService.showLoader();
    this.searchPlanTextTerminalError = false;
    this.selectedTerminalRoadError = false;
    this.isAddTrainError = false;
    if (this.locoPlannedTo === 'foreignRailRoad') {
      this.submitOperationForeignRoad(type);
    } else if (this.locoPlannedTo === 'train') {
      this.submitOperationTrain(type);
    } else if (this.locoPlannedTo === 'terminal') {
      this.submitOperationTerminal(type);
    }
  }

  /**
   * Submit operation Train
   * @param {string} type
   * @memberof LmsLocoTopActionsComponent
   */
  submitOperationTrain(type: string) {
    if (!this.appUtilityService.isValidTrainId(this.searchTextTrain)) {
      this.lmsLoaderService.hideLoader();
      this.isAddTrainError = true;
    } else {
      if (type === 'bringOnline') {
        const locoTransfer: Array<LocoTransfer> = [];
        this.createLocoTransferListForTrain(locoTransfer);
        this.serviceCallLocoTransfer(locoTransfer, 'XTRN', type);
      } else {
        if (this.locoSVG && this.locoSVG.intendedUsgaeNoteRequired && (!this.locoSVG.intendedUsageNote || (this.locoSVG.intendedUsageNote && this.locoSVG.intendedUsageNote.length === 0))) {
          this.lmsLoaderService.hideLoader();
          this.locoSVG.isIntendedUsageNotError = true;
        } else {
          if (this.locoSVG.intendedUsageNote) {
            this.locoSVG.intendedUsageNote = this.locoSVG.intendedUsageNote.trim().toUpperCase();
          }
          this.locoSVG.isIntendedUsageNotError = false;
          const locoId: Array<String> = [];
          locoId.push(this.appUtilityService.formatLocomotiveId(this.tab.tabSearchParameter.searchText));
          this.serviceCallToBre(this.searchTextTrain, locoId, type);
        }
      }
    }
  }

  /**
   * Submit operation Terminal
   * @param {string} type
   * @memberof LmsLocoTopActionsComponent
   */
  submitOperationTerminal(type: string) {
    if (!this.appUtilityService.isMnemonicExist(this.searchTextTerminal)) {
      this.lmsLoaderService.hideLoader();
      this.searchPlanTextTerminalError = true;
    } else {
      if (this.thpPlan && this.thpPlan.trim().toUpperCase() === 'S') {
        if (this.appUtilityService.isValidThpSelection(this.searchTextTerminal)) {
          this.submitTransferToTerminal(type);
        } else {
          this.lmsLoaderService.hideLoader();
          this.errorDialog = true;
          this.popupErrorMessage = this.configData.messages.invalidThpSelection;
        }
      } else {
        this.submitTransferToTerminal(type);
      }
    }
  }

  /**
   * Submit operation Foreign Road
   * @param {string} type
   * @memberof LmsLocoTopActionsComponent
   */
  submitOperationForeignRoad(type: string) {
    if (this.appUtilityService.isMnemonicExist(this.searchTextTerminal) && (this.selectedTerminalRoad && 'Select' !== this.selectedTerminalRoad)) {
      this.submitTransferToForeignRailRoad(type);
    } else {
      this.lmsLoaderService.hideLoader();
      if (!this.appUtilityService.isMnemonicExist(this.searchTextTerminal)) {
        this.searchPlanTextTerminalError = true;
      } else {
        this.searchPlanTextTerminalError = false;
      }
      if (!this.selectedTerminalRoad || 'Select' === this.selectedTerminalRoad) {
        this.selectedTerminalRoadError = true;
      } else {
        this.selectedTerminalRoadError = false;
      }
    }
  }

  /**
   * Service call for BRE (transfer to train operation).
   * @param {string} trainId
   * @param {Array<String>} locoId
   * @memberOf LmsLocoTopActionsComponent
   */
  private serviceCallToBre(trainId: string, locoId: Array<String>, type: string) {
    this.locoDataService.breTransferRequest(locoId, trainId).subscribe(
      (data) => {
        this.subscribeBreService(data, type);
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);
      }
    );
  }

  /**
   * This is subscribe method to bre transfer
   * @param {*} data
   * @param {string} type
   * @memberof LmsLocoTopActionsComponent
   */
  subscribeBreService(data: any, type: string) {
    const breTrasferParam: BreTransferAreaDetails = data;
    if (breTrasferParam && breTrasferParam.priorityCode) {
      const pCode = parseInt(breTrasferParam.priorityCode, 10);
      if (pCode >= 1 && pCode <= 4) {
        if (this.isLmsExceptionListExist(breTrasferParam)) {
          this.lmsLoaderService.hideLoader();
          this.popUpTypeBre = type;
          this[type] = false;
          this.ruleException = true;
          const newLmsExceptionList: Array<LmsException> = [];
          for (let i = 0; i < breTrasferParam.lmsExceptionList.length; i++) {
            const lmsException: LmsException = breTrasferParam.lmsExceptionList[i];
            if (this.locoSVG) {
              lmsException.intendedUsageDesc = this.appUtilityService.getIntendedUsageDesc(this.locoSVG.intendedUsageCode);
              lmsException.intendedUsageReason = this.appUtilityService.getIntendedUsageReasonDesc(this.locoSVG.intendedUsageReason);
              lmsException.intendedUsageNote = this.locoSVG.intendedUsageNote;
            }
            lmsException.isSelectedLoco = false;
            newLmsExceptionList.push(lmsException);
          }
          this.lmsExceptionList = newLmsExceptionList;
          const checkedExceptionList: Array<LmsException> = this.lmsExceptionList.filter((lmsException) => {
            return lmsException.isSelectedLoco;
          });
          if (checkedExceptionList && checkedExceptionList.length > 0) {
            this.isRuleExceptionSubmitEnabled = true;
          }

        } else {
          const locoTransfer: Array<LocoTransfer> = [];
          this.createLocoTransferListForTrain(locoTransfer);
          this.serviceCallLocoTransfer(locoTransfer, 'XTRN', type);
        }
      } else {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popupErrorMessage = breTrasferParam.messageText;
      }
    }
  }
  /**
   * Build Request for Update Teminal Handling Plan
   * @returns {TerminalHandlingUpdateRequest}
   * @memberOf LmsLocoTopActionsComponent
   */
  private buildUpdateRquest(): TerminalHandlingUpdateRequest {
    const terminalHandlingLocoInfo = {
      locomotiveID: this.appUtilityService.formatLocomotiveId(this.tab.tabSearchParameter.searchText)
    };
    const terminalHandlingLocoInfoArr: Array<TerminalHandlingLocoInfo> = [];
    terminalHandlingLocoInfoArr.push(terminalHandlingLocoInfo);
    const terminalHandlingUpdateRequest = {
      thpTerminal: this.locoSVG.thpTerminal,
      terminalHandlingType: this.thpPlan,
      otherLocosList: terminalHandlingLocoInfoArr
    };
    return terminalHandlingUpdateRequest;
  }

  /**
   * Service Call to Update Terminal Handling Plan
   * @memberOf LmsLocoTopActionsComponent
   */
  submitThpOperation() {
    this.lmsLoaderService.showLoader();
    const terminalHandlingUpdateRequest = this.buildUpdateRquest();
    this.locoDataService.updateThp(terminalHandlingUpdateRequest).subscribe(
      (data) => {
        this.baseResponse = <BaseResponse>data;
        if (this.appUtilityService.isNumeric(this.baseResponse.header.priorityCode)) {
          const pCode = parseInt(this.baseResponse.header.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            this.terminalPlan = false;
            if (this.tab && this.tab.subTypeDetail) {
              this.tab.subTypeDetail[this.tab.subType.toLowerCase()].status = 'refresh';
            }
            this.locoDataService.load(this.tab, true, this.baseResponse.header.messageText);
          } else {
            this.lmsLoaderService.hideLoader();
            this.errorDialog = true;
            this.popupErrorMessage = this.baseResponse.header.messageText;
          }
        }
      }, error => {
        this.lmsLoaderService.hideLoader();
        this.errorDialog = true;
        this.popupErrorMessage = this.appUtilityService.getHttpErroMessage(error, false);

      }
    );
  }

  /**
   * Creating Request for Plan to Foreign Road
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} terminal
   * @param {string} terminalType
   * @param {string} road
   * @memberOf LmsLocoTopActionsComponent
   */
  private createLocoTransferListForForeignRoad(locoTransfer: Array<LocoTransfer>, terminal: string, terminalType: string, road: string) {
    const a = {
      currentTerminalIdentifier: this.locoSVG.currentUsageTerminal,
      toRoadIdentifier: road,
      terminalHandlingType: terminalType,
      atStation: terminal,
      locoTransferList: {
        locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(this.tab.tabSearchParameter.searchText),
        qualifier: this.locoSVG.qualifier,
        assignedOrPlanned: this.locoSVG.assignedPlannedFlag
      }
    };
    locoTransfer.push(a);
  }

  /**
   * Creating Request for Plan to Terminal
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} terminal
   * @param {string} terminalType
   * @memberOf LmsLocoTopActionsComponent
   */
  private createLocoTransferListForTerminal(locoTransfer: Array<LocoTransfer>, terminal: string, terminalType: string) {
    const a = {
      currentTerminalIdentifier: this.locoSVG.currentUsageTerminal,
      terminalIdentifier: terminal,
      terminalHandlingType: terminalType,
      locoTransferList: {
        locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(this.tab.tabSearchParameter.searchText),
        qualifier: this.locoSVG.qualifier,
        assignedOrPlanned: this.locoSVG.assignedPlannedFlag
      }
    };
    locoTransfer.push(a);
  }


  /**
   * Create Request for Transfer to Train
   * @param {Array<LocoTransfer>} locoTransfer
   * @memberOf LmsLocoTopActionsComponent
   */
  private createLocoTransferListForTrain(locoTransfer: Array<LocoTransfer>) {
    const a = {
      currentTerminalIdentifier: this.locoSVG.currentUsageTerminal,
      trainIdentifier: this.searchTextTrain,
      terminalHandlingType: this.thpPlan,
      locoTransferList: {
        locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(this.tab.tabSearchParameter.searchText),
        qualifier: this.locoSVG.qualifier,
        assignedOrPlanned: this.locoSVG.assignedPlannedFlag,
        intendedUsageCode: this.locoSVG.intendedUsageCode,
        intendedUsageReason: this.locoSVG.intendedUsageReason,
        intendedUsageNotes: this.locoSVG.intendedUsageNote
      }
    };
    locoTransfer.push(a);
  }


  /**
   * Reset Enter to Submit
   * @memberOf LmsLocoTopActionsComponent
   */
  private resetDefaultPageMode() {
    this.popupService.setPageMode('');
    this.popupService.setSubmitBtnId('');
  }
  /**
   * Submit Loco Transfer to terminal
   * @memberOf LmsLocoTopActionsComponent
   */
  private submitTransferToTerminal(type: string) {
    const locoTransfer: Array<LocoTransfer> = [];
    this.createLocoTransferListForTerminal(locoTransfer, this.searchTextTerminal, this.thpPlan);
    this.serviceCallLocoTransfer(locoTransfer, 'XSTA', type);
  }

  /**
   * Submit Loco Transfer to Foreign Road
   * @memberOf LmsLocoTopActionsComponent
   */
  private submitTransferToForeignRailRoad(type: string) {
    const locoTransfer: Array<LocoTransfer> = [];
    this.createLocoTransferListForForeignRoad(locoTransfer, this.searchTextTerminal, ' ', this.selectedTerminalRoad);
    this.serviceCallLocoTransfer(locoTransfer, 'XROD', type);
  }

  /**
   * Locate Loco TO Terminal
   * @param {string} subType
   * @param {string} type
   * @param {string} terminalMnemonic
   * @memberOf LmsLocoTopActionsComponent
   */
  private showTerminalTabData(subType: string, type: string, terminalMnemonic: string, locateLocoId: string) {
    this.resetDefaultPageMode();
    this.appUtilityService.locate(type, subType, terminalMnemonic, locateLocoId);
  }


  /**
   * Locate Loco to Train
   * @param {string} subType
   * @param {string} type
   * @param {string} trainIdentifier
   * @memberOf LmsLocoTopActionsComponent
   */
  private showTrainTabData(subType: string, type: string, trainIdentifier: string, locateLocoId: string) {
    this.resetDefaultPageMode();
    this.appUtilityService.locate(type, subType, trainIdentifier, locateLocoId);
  }

  /**
   * Submit operation from rule exception window.
   * @memberOf LmsLocoTopActionsComponent
   */
  ruleExceptionSubmit(type: string) {
    const locoTransfer: Array<LocoTransfer> = [];
    this.createLocoTransferListForBreException(locoTransfer);
    if (locoTransfer && locoTransfer.length > 0) {
      this.lmsLoaderService.showLoader();
      this.ruleException = false;
      this[type] = true;
      this.popupService.setPageMode('Dialog');
      this.popupService.setSubmitBtnId(type + 'LocoData');
      this.serviceCallLocoTransfer(locoTransfer, 'XTRN', type);
    }
  }

  /**
   * Create Request for Bre Request
   * @param {Array<LocoTransfer>} locoTransfer
   * @memberOf LmsLocoTopActionsComponent
   */
  private createLocoTransferListForBreException(locoTransfer: Array<LocoTransfer>) {
    for (let i = 0; i < this.lmsExceptionList.length; i++) {
      const lmsException: LmsException = this.lmsExceptionList[i];
      if (lmsException.isSelectedLoco) {
        let isException = false;
        if (lmsException.tripPlamCompExcptnInd && lmsException.tripPlamCompExcptnInd === 'E') {
          if (!lmsException.tripPlanOverrideCode) {
            this.lmsExceptionList[i].isLmsExceptionInAddReason = true;
            isException = true;
          } else {
            this.lmsExceptionList[i].isLmsExceptionInAddReason = false;
          }
        }
        if (lmsException.unschdQShopExcptnInd && lmsException.unschdQShopExcptnInd === 'Y') {
          if (!lmsException.unscheduledQShop) {
            this.lmsExceptionList[i].isLmsExceptionInAddQShop = true;
            isException = true;
          } else {
            this.lmsExceptionList[i].isLmsExceptionInAddQShop = false;
          }
        }
        if (!isException) {
          this.createLocoTransferList(locoTransfer, lmsException);
        }
      }
    }
  }

  /**
   * Create LocoTransfer Array
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {LmsException} lmsException
   * @memberof LmsLocoTopActionsComponent
   */
  createLocoTransferList(locoTransfer: Array<LocoTransfer>, lmsException: LmsException) {
    const a = {
      currentTerminalIdentifier: this.locoSVG.currentUsageTerminal,
      trainIdentifier: this.searchTextTrain,
      terminalHandlingType: this.thpPlan,
      locoTransferList: {
        locomotiveIdentifier: this.appUtilityService.formatLocomotiveId(lmsException.locoId),
        qualifier: this.locoSVG.qualifier,
        assignedOrPlanned: this.locoSVG.assignedPlannedFlag,
        tripPlanCompIndicator: lmsException.tripPlamCompExcptnInd,
        tripPlanTrainIdentifier: lmsException.tripPlanTrnId,
        tripPlanOverrideCode: lmsException.tripPlanOverrideCode,
        tripPlanOverrideReason: lmsException.tripPlanOverrideReason,
        unscheduledQShop: lmsException.unscheduledQShop,
        unscheduledQShopDate: lmsException.unscheduledQShopDate,
        intendedUsageCode: this.locoSVG.intendedUsageCode,
        intendedUsageReason: this.locoSVG.intendedUsageReason,
        intendedUsageNotes: this.locoSVG.intendedUsageNote
      }
    };
    locoTransfer.push(a);
  }

  /**
   * Check if Locomotive is checked or not in BRE
   * @param {any} event
   * @memberOf LmsLocoTopActionsComponent
   */
  checkCheckedLoco(event) {
    const checkedExceptionList: Array<LmsException> = this.lmsExceptionList.filter((lmsException) => {
      return lmsException.isSelectedLoco;
    });
    if (checkedExceptionList && checkedExceptionList.length > 0) {
      this.isRuleExceptionSubmitEnabled = true;
    } else {
      this.isRuleExceptionSubmitEnabled = false;
    }
  }



  /**
   * Check If Exception List exists or not
   * @param {BreTransferAreaDetails} breTrasferParam
   * @returns {boolean}
   * @memberOf LmsLocoTopActionsComponent
   */
  private isLmsExceptionListExist(breTrasferParam: BreTransferAreaDetails): boolean {
    if (breTrasferParam && breTrasferParam.lmsExceptionList && breTrasferParam.lmsExceptionList.length > 0) {
      for (let i = 0; i < breTrasferParam.lmsExceptionList.length; i++) {
        const lmsExcpetion = breTrasferParam.lmsExceptionList[i];
        if (lmsExcpetion && 'E' === lmsExcpetion.tripPlamCompExcptnInd) {
          return true;
        }
        if (lmsExcpetion && 'Y' === lmsExcpetion.unschdQShopExcptnInd) {
          return true;
        }
        if (lmsExcpetion && lmsExcpetion.exceptionMessage && lmsExcpetion.exceptionMessage.length > 0) {
          return true;
        }
      }
    }
    return false;
  }


  /**
   * This method checks that button will be disabled if mandatory fields are not filled
   * @returns
   * @memberof LmsLocoTopActionsComponent
   */
  checkMandatoryCondition() {
    let buttonDisable = false;
    if (this.locoPlannedTo === 'foreignRailRoad' && !this.searchTextTerminal && !this.selectedTerminalRoad) {
      buttonDisable = true;
    } else if (this.locoPlannedTo === 'train' && !this.searchTextTrain) {
      buttonDisable = true;
    } else if (this.locoPlannedTo === 'terminal' && !this.searchTextTerminal) {
      buttonDisable = true;
    }
    return buttonDisable;
  }

  /**
   * Get State city name of Terminal
   * @param {string} terminalMnemonic
   * @returns {string}
   * @memberof LmsLocoTopActionsComponent
   */
  getTerminalCityState(terminalMnemonic: string): string {
    if (this.terminalCommonInfoArr && terminalMnemonic) {
      const terminalCommonInfo: TerminalCommonInfo = this.appUtilityService.getTerminalInfoObject(terminalMnemonic);
      if (terminalCommonInfo && terminalCommonInfo.city && terminalCommonInfo.stateCode) {
        return terminalCommonInfo.city.trim() + ', ' + terminalCommonInfo.stateCode.trim();
      }
    }
    return '-';
  }

  /**
   * Changes for Focus on Dialog
   * @param {string} id
   * @memberof LmsLocoTopActionsComponent
   */
  focusOnDialog(id: string) {
    setTimeout(() => {
      this.appUtilityService.setFocusToFirstElement(id);
    }, 20);
  }

  public setFocusToGivenElement(inputId: string, timeOut?: string) {
    if (inputId && inputId.length > 0) {
      if (!timeOut) {
        const input = document.getElementById(inputId);
        if (input) {
          setTimeout(() => {
            input.focus();
          }, 20);
        }
      }
      if (timeOut) {
        setTimeout(() => {
          const input = document.getElementById(inputId);
          if (input) {
            input.focus();
          }
        }, 20);
      }
    }
  }
  ngOnDestroy() {
    this.popUpServiceSubscription.unsubscribe();
    if (this.iconSubscription) {
      this.iconSubscription.unsubscribe();
    }
  }
}

